import { defineTrpcContract, mutation, query } from "@amtana/module";

import { prospectScopeSchema } from "./prospect-conditions.schemas.ts";
import {
  changedCountSchema,
  countMatchingOutputSchema,
  getProspectInputSchema,
  listProspectsInputSchema,
  prospectPageSchema,
  prospectSchema,
  removeProspectsInputSchema,
  scoreInputSchema,
  scoreOutputSchema,
  updateProspectsInputSchema,
} from "./prospect.schemas.ts";

export const prospectTrpcContract = defineTrpcContract("prospect", {
  list: query({ input: listProspectsInputSchema, output: prospectPageSchema }),
  get: query({ input: getProspectInputSchema, output: prospectSchema }),
  score: query({ input: scoreInputSchema, output: scoreOutputSchema }),
  countMatching: query({ input: prospectScopeSchema, output: countMatchingOutputSchema }),
  update: mutation({ input: updateProspectsInputSchema, output: changedCountSchema }),
  remove: mutation({ input: removeProspectsInputSchema, output: changedCountSchema }),
});
